import type { ReactElement } from "react";
import { getLogoColor } from "../Logo";

type LogoColor = "black" | "white" | "light" | "dark";

interface Props {
  color?: LogoColor;
  height?: number;
}

const DEFAULT_HEIGHT = 38;
const ASPECT_RATIO = 751 / 335;

export default function OliLogo({
  color = "dark",
  height = DEFAULT_HEIGHT,
}: Props): ReactElement {
  const fill = getLogoColor(color);
  const width = Math.round(height * ASPECT_RATIO);

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 751 335"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M113.729 100.054C50.9244 100.054 0 150.82 0 213.429C0 276.039 50.9244 326.805 113.729 326.805C176.535 326.805 227.459 276.039 227.459 213.429C227.459 150.82 176.535 100.054 113.729 100.054ZM113.729 260.679C87.5669 260.679 66.3317 239.535 66.3317 213.429C66.3317 187.323 87.5419 166.179 113.729 166.179C139.917 166.179 161.127 187.323 161.127 213.429C161.127 239.535 139.917 260.679 113.729 260.679Z"
        fill={fill}
      />
      <path d="M306.412 15.8774V321.151H242.555V15.8774H306.412Z" fill={fill} />
      <path d="M327.081 321.149V105.719H390.936V321.149H327.081Z" fill={fill} />
      <path
        d="M359.037 81.1525C379.978 81.1525 396.955 64.2289 396.955 43.3525C396.955 22.4761 379.978 5.55249 359.037 5.55249C338.095 5.55249 321.118 22.4761 321.118 43.3525C321.118 64.2289 338.095 81.1525 359.037 81.1525Z"
        fill={fill}
      />
      <path
        d="M497.898 246.607L534.616 335C594.421 310.315 658.603 312.11 714.006 335L750.725 246.607C672.61 214.342 582.165 211.798 497.873 246.607H497.898Z"
        fill={fill}
      />
      <path
        d="M624.356 0C571.456 0 528.56 42.7619 528.56 95.4974C528.56 148.233 571.456 190.995 624.356 190.995C677.256 190.995 720.152 148.233 720.152 95.4974C720.152 42.7619 677.256 0 624.356 0ZM624.356 135.292C602.321 135.292 584.437 117.489 584.437 95.4974C584.437 73.5056 602.296 55.7027 624.356 55.7027C646.417 55.7027 664.275 73.5305 664.275 95.4974C664.275 117.464 646.392 135.292 624.356 135.292Z"
        fill={fill}
      />
    </svg>
  );
}
